/** @format */
import { toSnakeCase } from '@toucan/common/helpers/change-case';
import { getSearchParamKey } from '@toucan/common/services/search/helpers';

import { SearchParam } from '@toucan/client/global/nextjs';

import { Filter } from '@toucan/client/features/search/config/types';

export function transformFiltersToSearchParams(filters: Filter[]): SearchParam {
    return filters.reduce<SearchParam>((searchParams, filter) => {
        const selectedValues = filter.selectedOptions.map((option) =>
            option.value.toString()
        );

        searchParams[getSearchParamKey(filter.id)] = selectedValues.length
            ? selectedValues
            : undefined;

        searchParams[`variant_${toSnakeCase(filter.id)}`] =
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
            filter.selectedVariant || undefined;

        return searchParams;
    }, {});
}
